import { createFileRoute } from "@tanstack/react-router"
import { NavigationHeader } from "@/components/e2e/layout/NavigationHeader"
import { TaskKanbanScreen } from "@/components/agents/tasks/TaskKanbanScreen"
import { usePageHead } from "../../../compat/head"

// Port of app/agents/tasks/[picId]/page.tsx (was an async server component —
// params now come from the route instead of awaited props).
export const Route = createFileRoute("/agents/tasks/$picId")({
  component: AgentTasksByPicPage,
})

function AgentTasksByPicPage() {
  const { picId } = Route.useParams()
  usePageHead({ title: "Task Agents - PIC support · theo PIC" })
  return (
    <div className="min-h-screen bg-background">
      <NavigationHeader currentPage="agents" />
      <>
        <TaskKanbanScreen picId={picId} />
      </>
    </div>
  )
}
